import interactionParserUtils from './InteractionParserUtils';
import xmlDomUtils from '../../../utils/XmlDomUtils';
import Constants from '../../../Constants';

const extendedTextParser = {
    parse(interaction, language, defaultLanguage) {
        const attributes = xmlDomUtils.getAttributes(interaction);
        const { autoExpand, autosave, expectedLength, initialNumberOfLines, usePlainText } = attributes;
        let { expectedLines, format } = attributes;
        if (!format) {
            format = usePlainText === 'true' ? 'plain' : 'xhtml';
        }
        const showWordCountAttr = attributes['inspera:showWordCount'];
        const variant = attributes['inspera:variant'] || '';
        const editorToolbar = attributes['inspera:editorToolbar'] || Constants.editorToolbarModes.DEFAULT;
        const showWordCount = (showWordCountAttr === undefined && format !== 'plain') || showWordCountAttr === 'true';
        const prompt = interactionParserUtils.getPrompt(interaction, language, defaultLanguage);

        expectedLines = parseInt(expectedLines, 10);
        if (isNaN(expectedLines)) {
            expectedLines = parseInt(initialNumberOfLines, 10);
            if (isNaN(expectedLines)) {
                if (variant === 'math') {
                    expectedLines = 1;
                } else {
                    expectedLines = format === 'plain' ? 9 : 17;
                }
            }
        }

        let maxWords = parseInt(attributes['inspera:maxWords'], 10);
        if (isNaN(maxWords)) {
            maxWords = 0;
        }
        let fieldWidth = attributes['inspera:fieldWidth'] || '';

        if (variant === 'math') {
            if (fieldWidth && (fieldWidth.indexOf('%') > 0 || fieldWidth.indexOf('px') > 0)) {
                const unitIndex = fieldWidth.indexOf('%') > 0 ? fieldWidth.indexOf('%') : fieldWidth.indexOf('px');
                const fieldWidthValue = parseInt(fieldWidth.substr(0, unitIndex), 10);
                if (isNaN(fieldWidthValue)) {
                    fieldWidth = '100%';
                }
            } else {
                fieldWidth = '100%';
            }
        }

        return {
            autoExpand: autoExpand !== 'false',
            autoSaveInterval: isNaN(parseInt(autosave, 10)) ? 0 : parseInt(autosave, 10),
            editorToolbar,
            expectedLength: isNaN(parseInt(expectedLength, 10)) ? 0 : parseInt(expectedLength, 10),
            expectedLines,
            fieldWidth,
            format,
            maxWords,
            showWordCount,
            prompt,
            variant,
        };
    },
};

export default extendedTextParser;
